export default __webpack_public_path__ + "static/media/sponsor-icon-active.dc84779b.webp";